import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  strategySimulatorAllIds,
  strategySimulatorById,
  allStrategySimulatorsSelector,
] = resourceSelectors('strategySimulator');
